<template>
  <form @submit="getOnLoadMessageLogs">
    <div class="jumbotron">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="integrated_number" class="col-form-label">Integrated Number <span
                class="text-danger">*</span></label>
            <select class="form-control" id="integrated_number" v-model="integrated_number"
                    :disabled="validated == 1" required>
              <option v-for="(option, key) in phones" :value="option.phonenumberId" :key="key">{{
                  option.name
                }}
                (+91 {{ option.phonenumber }})
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="date_range_picker" class="col-form-label">Choose date <span
                class="text-danger">*</span></label>
            <date-range-picker
                style="width: 100%;"
                ref="picker"
                class="form-control"
                :opens="dateRangeConf.opens"
                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                :minDate="dateRangeConf.minDate" :maxDate="dateRangeConf.maxDate"
                :singleDatePicker="dateRangeConf.singleDatePicker"
                :timePicker="dateRangeConf.timePicker"
                :timePicker24Hour="dateRangeConf.timePicker24Hour"
                :showWeekNumbers="dateRangeConf.showWeekNumbers"
                :showDropdowns="dateRangeConf.showDropdowns"
                :autoApply="dateRangeConf.autoApply"
                v-model="expiryDate"
            >
            </date-range-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="integrated_number" class="col-form-label">Direction <span
                class="text-danger">*</span></label>
            <select class="form-control" id="direction" v-model="direction" required>
              <option value="outbound">Outbound</option>
              <option value="inbound">Inbound</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="phonenumber" class="col-form-label">Phonenumber <span
                class="text-danger" v-show="false">*</span></label>
            <input type="text" class="form-control" minlength="10" maxlength="10" v-model="phonenumber"
                   id="phonenumber" placeholder="Enter 10 digit to search...">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="rowCount" class="col-form-label">Row Count (10 - 12000)<span
                class="text-danger" v-show="true">*</span></label>
            <input type="number" class="form-control" min="10" max="12000" v-model="rowCount"
                   id="rowCount" placeholder="Enter needed rows count" required>
          </div>
        </div>
      </div>
      <!--            <div class="col-md-1">-->
      <!--                <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-purple rounded shadow-sm">-->
      <!--                    <div class="lh-100">-->
      <!--                        <button type="submit" class="btn btn-info">Filter</button>-->
      <!--                    </div>&nbsp;<br>-->
      <!--                    <div class="lh-100" v-show="exportDivShowHide == true">-->
      <!--                        <button type="button" class="btn btn-info" v-on:click="onPrintQuickFilterTexts(false)">-->
      <!--                            Export All Data-->
      <!--                        </button>-->
      <!--                    </div>&nbsp;&nbsp;&nbsp;-->
      <!--                    &lt;!&ndash;          <div class="lh-100">&ndash;&gt;-->
      <!--                    &lt;!&ndash;            <button type="button" class="btn btn-info" v-on:click="onPrintQuickFilterTexts(true)">Export Filtered Data&ndash;&gt;-->
      <!--                    &lt;!&ndash;            </button>&ndash;&gt;-->
      <!--                    &lt;!&ndash;          </div>&ndash;&gt;-->
      <!--                </div>-->
      <!--            </div>-->
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-auto">
            <button type="submit" class="btn btn-info">Filter</button>
          </div>
          <div class="col-auto" v-show="exportDivShowHide == true">
            <button type="button" class="btn btn-info" v-on:click="onPrintQuickFilterTexts(false)">
              Export All Data
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-md-12">
      <small class="pl-1 text-danger">This table shows maximum
        {{ rowCount > 12000 ? 12000 : (rowCount < 10 ? 10 : rowCount) }} recent record</small>
      <div class="table-responsive">
        <div style="height: 100%">
          <div class="example-wrapper">
            <div class="example-header">
              <input type="text" class="form-control" id="filter-text-box" placeholder="Search here..."
                     v-on:input="onFilterTextBoxChanged()">
            </div>
            <ag-grid-vue
                domLayout="autoHeight"
                style="width: 100%; height: 100%;"
                class="ag-theme-alpine"
                :columnDefs="columnDefs"
                @grid-ready="onGridReady"
                :defaultColDef="defaultColDef"
                :rowData="rowData"
                :cacheQuickFilter="true"
                :pagination="true"></ag-grid-vue>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from 'moment';
import DateRangePicker from 'daterange-picker-vue3'
//you need to import the CSS manually
import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'
import {AgGridVue} from "ag-grid-vue3";  // the AG Grid Vue Component
// import { reactive, onMounted, ref } from "vue";

import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import * as XLSX from 'xlsx';

export default {
  components: {
    DateRangePicker,
    'ag-grid-vue': AgGridVue,
  },

  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    // 15th two months prior
    // const minDate = new Date(today)
    // minDate.setMonth(minDate.getMonth() - 2)
    // minDate.setDate(15)

    // 15th in two months
    const maxDate = new Date(today)
    const nextFollowDate = new Date()
    const yesterdayDate = new Date()
    const sevenDate = new Date()
    // maxDate.setMonth(maxDate.getMonth() + 2)
    // maxDate.setDate(now.getDate() + 15)
    nextFollowDate.setDate(now.getDate() + 3)
    yesterdayDate.setDate(now.getDate() - 1)
    sevenDate.setDate(now.getDate() - 7)
    return {
      columnDefs: [
        {
          headerName: 'FROM',
          field: 'from',
          flex: 1
        },
        {
          headerName: 'TO',
          field: 'to',
          flex: 1
        },
        {
          headerName: 'USER NAME',
          field: 'inBoundUserName',
          flex: 1,
          valueGetter: (params) => params.data?.inBoundUserName || ' - '
        },
        {
          headerName: 'MESSAGE',
          field: 'message',
          cellRenderer: params => {
            if (params.data?.type !== undefined && params.data.type == 'image') {
              var url = `https://nithraapps.in:3011/inBound/media/download?integrated_number=${params.data.integrated_number}&media_id=${params.data.media_id}`;
              // const url = 'http://localhost:3011/inBound/media/download?integrated_number=255853340934707&media_id=410528768702414'; // Replace with your actual URL
              const title = 'Click to view'; // Your title
              const mimeType = `mime_type: image/jpeg ${params.data.media_id}`; // Assuming you have this data
              const linkElement = document.createElement('a');
              linkElement.href = url;
              linkElement.target = '_blank';
              linkElement.title = title;
              linkElement.classList.add('custom-link');
              linkElement.textContent = mimeType;

              return linkElement;
            } else
              return params.value;
          },
          flex: 3,
          autoHeight: true,
          wrapText: true
        },
        {
          headerName: 'TEMPLATE',
          field: 'template'
        },
        {
          headerName: 'STATUS',
          field: 'status'
        },
        {
          headerName: 'TIMESTAMP',
          field: 'timestamp',
          valueFormatter: (params) => {
            if (params.value) {
              return moment(params.value).format('DD-MM-YYYY hh:mm:ss a')
            }
          }
        }
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        flex: 1,
        editable: true,
      },
      rowData: null,
      dateRangeConf: {
        opens: 'center',
        minDate: 'center',
        maxDate: maxDate,
        singleDatePicker: false,
        timePicker: false,
        timePicker24Hour: false,
        showWeekNumbers: false,
        showDropdowns: false,
        autoApply: false,
      },
      expiryDate: {
        'startDate': maxDate,
        'endDate': maxDate
      },
      startDate: "",
      validated: 0,
      exportDivShowHide: false,
      tables: [],
      waId: '',
      show: true,
      phones: [],
      WaIDtables: [],
      integrated_number: "103758689422024",
      direction: "outbound",
      phonenumber: "",
      rowCount: 500
    }
  },
  async created() {
    this.waId = this.$route.params.waId
    var getWaId = await this.getNumberIntegrationList();
    this.phones = getWaId.data.message;
    // var getTemp = await this.getMessageLogs();
    // this.tables = getTemp.data;
    this.rowData = [];
    // if (this.rowData.length)
    //   this.exportDivShowHide = true;
    // else
    //   this.exportDivShowHide = false;
  },
  methods: {
    format_date(value) {
      if (value) {
        return moment(value).format('DD-MM-YYYY hh:mm:ss a')
      }
    },
    async getMessageLogs() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/message_logs';
      return await this.axiosRequest(templateURL, {
        expiryDate: {
          startDate: new Date(moment(this.expiryDate.startDate).format('YYYY-MM-DD 00:00:00')).toISOString(),
          endDate: new Date(moment(this.expiryDate.endDate).format('YYYY-MM-DD 23:59:59')).toISOString()
        },
        integrated_number: this.integrated_number,
        direction: this.direction,
        phonenumber: this.phonenumber,
        rowCount: this.rowCount,
        waId: this.waId
      });
    },
    async getOnLoadMessageLogs(event) {
      event.preventDefault()
      var getTemp = await this.getMessageLogs();
      this.tables = getTemp.data;
      this.rowData = this.tables;
      // this.rowData.forEach((value, index) => {
      //   if (value.type == 'image') {
      //     var redirectUrl = `http://localhost:3011/inBound/media/download?integrated_number=${value.integrated_number}&media_id=${value.media_id}`;
      //     this.rowData[index].message = `<a href="${redirectUrl}" target="_blank" title="Click to view" class="custom-link">${value.message}</a>`
      //   }
      // })
      if (this.rowData.length)
        this.exportDivShowHide = true;
      else
        this.exportDivShowHide = false;
    }, async getPhones() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/phone_numbers?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/phone_numbers';
      const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': NMPUSER.token,
        }
      }
      return await axios.post(templateURL,
          {
            waId: this.waId
          }, // the data to post
          config).then(function (response) {
        return response;
      });
    },
    onFilterTextBoxChanged() {
      this.gridApi.setQuickFilter(
          document.getElementById('filter-text-box').value
      );
      if (this.gridApi.getDisplayedRowCount())
        this.exportDivShowHide = true;
      else
        this.exportDivShowHide = false;
    },
    onPrintQuickFilterTexts(exportMode) {
      let rowData = [];
      if (exportMode)
        this.gridApi.forEachNodeAfterFilter(node => rowData.push(node.data));
      else
        this.gridApi.forEachNode(node => {
          if (node.data.message.length > 32767)
            node.data.message = node.data.message.slice(0, 32760) + "..."
          rowData.push(node.data)
        });
      // this.gridApi.forEachNode(function (rowNode, index) {
      //   var obj = [];
      //   obj.push(index);
      //   obj.push(rowNode.from);
      //   obj.push(rowNode.to);
      //   obj.push(rowNode.template);
      //   obj.push(rowNode.message);
      //   obj.push(rowNode.timestamp);
      //   rowData.push(obj);
      // });
      // Add hyperlinks to the data
      rowData = rowData.map(row => {
        if (row.type === 'image') {
          const url = `https://nithraapps.in:3011/inBound/media/download?integrated_number=${row.integrated_number}&media_id=${row.media_id}`;
          return {
            ...row,
            message: { t: 's', v: row.message, l: { Target: url }, s: { font: { color: { rgb: "0000FF" }, underline: true } } }
            // message: `=HYPERLINK("${url}", "${row.message}")`
          };
        }
        return row;
      });

      var filename = "NMS_" + moment(new Date()).format('YYYYMMDDHHMMSS') + '.xlsx';
      var data = rowData;
      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, filename);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    async getNumberIntegrationList() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}

div.vue-daterange-picker {
  width: 100% !important;
}

/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
